module.exports = __webpack_public_path__ + "img/ecp_logo_white.6af11a54.svg";